export interface DataPolicyProps {
  renderedView: any;
  title: string;
}

export const getDataPolicy = async (): Promise<DataPolicyProps> => {
  try {
    const response = await fetch('/TermsAndConditions/GetPrivacyPolicyPartial', {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    return await response.json();
  } catch (error) {
    throw new Error(error);
  }
};
